module.exports = __webpack_public_path__ + "images/card-discover.6848d66e3a71a840a8ff240b333d0ca1.svg";